<template>
  <div class="address-edit-wrapper">
    <div class="del-address" v-if="addressId" @click="delAddressShow = true"><icon icon-class="del"></icon>删除地址</div>
    <div class="edit-wrapper">
      <div class="edit-item">
        <div class="edit-type">收件人<span>*</span></div>
        <div class="edit-content">
          <input type="text" class="edit-input" v-model="username" placeholder="收件人姓名">
        </div>
      </div>
      <div class="edit-item">
        <div class="edit-type">手机号<span>*</span></div>
        <div class="edit-content">
          <input type="number" class="edit-input" v-model="phone" placeholder="联系电话">
        </div>
      </div>
      <div class="edit-item">
        <div class="edit-type">省市地区<span>*</span></div>
        <div class="edit-content">
          <div class="address-picker" @click="addressPickerShow = true">
            <span class="placeholder" v-if="!cityCode">请选择</span>
            <span class="address-value" v-else>{{area.province}}-{{area.city}}-{{area.district}}</span>
          </div>
        </div>
  
      </div>
      <div class="edit-item">
        <div class="edit-type">详细地址<span>*</span></div>
        <div class="edit-content">
          <input type="text" class="edit-input" v-model="address" maxlength="64" placeholder="详细地址">
        </div>
      </div>
      <div class="save-address"><button class="save-button" @click="saveAddress" :disabled="saveing">保存</button></div>
    </div>

    <!-- 地区选择 -->
    <van-popup v-model="addressPickerShow" position="bottom">
      <van-area
        :area-list="areaList"
        :columns-num="3"
        title="省市地区"
        :value="cityCode"
        @cancel="addressPickerShow = false"
        @confirm="confirmLocation" />
    </van-popup>
    <!-- 删除弹窗 -->
    <x-dialog v-if="delAddressShow" title="删除地址" @close="delAddressShow = false">
      <div class="del-content">
        <div class="text">是否删除该收货地址</div>
        <div class="del-control">
          <button class="cancel" @click="delAddressShow = false">取消</button>
          <button class="confirm" @click="delAddress">确定</button>
        </div>
      </div>
    </x-dialog>
  </div>
</template>

<style lang="less" scoped>
  .address-edit-wrapper{
    min-height: 100vh;
    border-width: 12px 8px;
    border-color: #F7F7F7;
    border-style: solid;
    background: #FFF;
    .del-address{
      background: #F7F7F7;
      padding: 8px 12px 10px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 14px;
      line-height: 14px;
      color: #999;
      svg{
        position: relative;
        top: -1px;
        font-size: 14px;
        margin-right: 4px;
        color: #999;
      }
    }
    .edit-wrapper{
      background: #FFF;
      padding: 24px 16px 0;
      border-radius: 6px;
      min-height: 100%;
      .edit-item{
        margin-bottom: 32px;
        .edit-type{
          font-size: 14px;
          line-height: 14px;
          color: #666;
          font-weight: bold;
          span{
            line-height: 14px;
            font-size: 16px;
            margin-left: 4px;
            color: @error;
          }
        }
        .edit-content{
          margin-top: 12px;
          height: 48px;
          width: 100%;
          background: #f7f7f7;
          border-radius: 4px;
          .edit-input{
            width: 100%;
            background: #F7F7F7;
            font-size: 14px;
            line-height: 14px;
            padding: 17px 12px;
            color: @black;
          }
          .address-picker{
            width: 100%;
            background: #F7F7F7;
            font-size: 14px;
            line-height: 14px;
            padding: 17px 12px;
            color: @black;
            .placeholder{
              color: #999;
            }
          }
        }
      }
      .save-address{
        margin-top: 48px;
        .save-button{
          @button-base();
          width: 100%;
          height: 40px;
        }
      }
    }
    .del-content{
      padding: 40px 0 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .text{
        text-align: center;
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
        color: @black;
      }
      .del-control{
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          width: 136px;
          height: 36px;
          &.cancel{
            @button-border();
            margin-right: 13px;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import areaList from '@/untils/area'
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        addressId: '',
        saveing: false,
        username: '',
        phone: '',
        address: '',
        addressPickerShow: false,
        areaList,
        area: {
          province: '',
          city: '',
          district: '',
        },
        cityCode: '',
        delAddressShow: false,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    components: {
      xDialog
    },
    created() {
      this.addressId = this.$route.query.address_id || '';
      if(this.addressId) {
        this.$root.post('/getAddressDetail', {
          address_id: this.addressId
        }).then(data => {
          console.log(data);
          if(data) {
            this.username = data.name;
            this.phone = data.mobile;
            this.address = data.region;
            this.cityCode = data.city_code;
            this.area = {
              province: data.province,
              city: data.city,
              district: data.country
            }
          }
        })
      }
    },
    methods: {
      // 确认选择地区
      confirmLocation(location) {
        console.log(location)
        this.area = {
          province: location[0].name,
          city: location[1].name,
          district: location[2].name
        }
        this.cityCode = location[2].code;
        this.addressPickerShow = false;
      },
      // 删除地址
      delAddress() {
        this.$root.post('/delAddress', {
          address_id: this.addressId
        }).then(data => {
          if(data.status == 1) {
            this.$notify({
              background: '#00848A',
              message: '删除成功'
            })
            this.$router.go(-1)
          }
        })
      },
      saveAddress() {
        if(!this.username) {
          this.$notify('请输入收件人姓名');return;
        }
        if(!this.phone){
          this.$notify('请输入手机号');return;
        }
        if(!/^1\d{10}$/.test($.trim(this.phone))){
          this.$notify('请输入正确的手机号');return;
        }
        if(!this.cityCode){
          this.$notify('请选择省市地区');return;
        }
        if(!this.address){
          this.$notify('请输入详细地址');return;
        }
        let postData = {
          user_id: this.userInfo.user_id,
          name: this.username,
          mobile: this.phone,
          province: this.area.province,
          city: this.area.city,
          country: this.area.district,
          region: this.address,
          city_code: this.cityCode,
        }
        if(this.addressId) {
          postData.address_id = this.addressId;
        }
        this.saveing = true;
        this.$root.post('/setUserAddress', postData).then(data => {
          if(data.status == 1) {
            this.$notify({
              background: '#00848A',
              message: '保存成功'
            })
            setTimeout(() => {
              this.$router.go(-1)
            }, 1000);
          }else {
            this.saveing = false;
            this.$notify(data.msg);
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Address/edit.vue